// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3R_Tn","requiredAsterisk":"Info_requiredAsterisk__MvdHD"};